import { useLocalization } from '@ais-ui/locale-management';
import { useMapPanelContext } from '../Map/MapPanel';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiList } from 'react-icons/pi';
import React from 'react';

export const CollapsedReportDetails = () => {
  const { messages } = useLocalization();
  const { setReportDetailsExpanded } = useMapPanelContext();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={() => setReportDetailsExpanded(true)}
          variant="outline"
          size="icon"
        >
          <PiList className="h-6 w-6" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Expand report details</TooltipContent>
    </Tooltip>
  );
};
